import type { StringifyOptions, ParseOptions } from 'query-string';
import { stringify, parse } from 'query-string';

const queryStringify = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queries: Record<string, any>,
  options?: StringifyOptions,
) =>
  stringify(queries, {
    arrayFormat: 'bracket',
    skipEmptyString: true,
    ...options,
  });

const queryStringToObject = (query: string, options?: ParseOptions) =>
  parse(query, {
    arrayFormat: 'bracket',
    sort: false,
    parseBooleans: true,
    ...options,
  });

export { queryStringify, queryStringToObject };
